import create from 'zustand';
import createStoreSelectors from './utils/createStoreSelector';

const useStore = create((set) => ({
  isBatchSubscribed: false,
  setIsBatchSubscribed: (value) => {
    set((state) => ({
      ...state,
      isBatchSubscribed: value
    }));
  }
}));

const useIsBatchSubscribedStore = createStoreSelectors(useStore);

export default useIsBatchSubscribedStore;
